/* eslint-disable no-redeclare */

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'

import React, { useState } from 'react'
import DirectionSnackbar from './Snackbar'
import { Popover, Typography } from '@mui/material'
import ComboBox from './ComboBox'
import { makeGetRequest } from 'utils/api'
import { makePutRequest } from 'utils/api'
import { makePostRequest } from 'utils/api'

const Mlist = [
  { label: 'Finance', id: 'Finance' },
  { label: 'Personnel', id: 'Personnel' },
  { label: 'Social', id: 'Social' },
  { label: 'Santé ', id: 'Santé' },
  { label: 'Sport ', id: 'Sport' },
  { label: 'Consommation', id: 'Consommation' },
  { label: 'Habitation', id: 'Habitation' },
  { label: 'Professionnel', id: 'Professionnel' },
  { label: 'Administratif', id: 'Administratif' },
  { label: 'Temps', id: 'Temps' },
  { label: 'Animal', id: 'Animal' },
]
const Classilist = [
  { label: 'Dépense nécessaire fixe', id: 'Dépense nécessaire fixe' },
  { label: 'Dépense nécessaire variable', id: 'Dépense nécessaire variable' },
  { label: 'Dépense secondaire fixe', id: 'Dépense secondaire fixe' },
  { label: 'Dépense secondaire variable', id: 'Dépense secondaire variable' },
  { label: 'Epargne', id: 'Epargne' },
  { label: 'Revenu', id: 'Revenu' },
  { label: 'Passive', id: 'Passive' },
  { label: 'Autre', id: 'Autre' },
]

export default function CreateCategory({ handleChange, label, selected, categories }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [catOpen, setCatOpen] = React.useState(false)
  const [mouvementOpen, setMouvementOpen] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const [categoryList, setCategoryList] = React.useState([])
  const [moduleList, setModuleList] = React.useState(Mlist)
  const [mouvementList, setMouvementList] = React.useState([
    { label: 'Dépense', id: 'Dépense' },
    { label: 'Revenu', id: 'Revenu' },
  ])
  const [classificationList, setClassificationList] = React.useState([
    {
      label: 'Select Mouvement First',
      id: '1',
    },
  ])
  const [createCategory, setCreateCategory] = React.useState({
    Categorie: '',
    SousCategorie: '',
    Mouvement: '',
    Module: '',
    Classification: '',
    id: '',
  })

  const fetchCategory = async () => {
    const { data } = await makeGetRequest('/api/Finance/Categoriesfi/' + selected[0], {}, true)
    setCreateCategory(data)
  }
  const [openSnack, setOpenSnak] = useState({
    message: '',
    color: '',
    open: false,
  })
  const handleClickOpen = () => {
    setOpen(true)

    if (selected && selected.length === 1) {
      fetchCategory()
    } else if (selected && selected.length > 1) {
      alert('Please Select 1 Category to modify')
      handleClose()
    }
  }
  const handleChange1 = (e) => {
    setCreateCategory({ ...createCategory, [e.target.name]: e.target.value })
  }
  const handleClose = () => {
    setOpen(false)
    setAnchorEl(null)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    if (selected && selected.length >= 1) {
      var { data } = await makePutRequest('/api/Finance/add/category/', createCategory, {}, true)
      setOpenSnak({
        open: true,
        color: 'success',
        message: 'Successfully Edit catégorie',
      })
      setTimeout(() => {
        setOpenSnak({
          open: false,
          color: 'success',
          message: 'Account add Successfully',
        })
      }, 2000)
      handleChange()
      handleClose()
    } else {
      var { data } = await makePostRequest('/api/Finance/add/category/', createCategory, {}, true)

      if (data === 'Categories already exist') {
        setOpenSnak({
          open: true,
          color: 'success',
          message: 'Sous-catégorie déjà existante pour ce type de mouvement',
        })
        setTimeout(() => {
          setOpenSnak({
            open: false,
            color: 'success',
            message: 'Sous-catégorie déjà existante pour ce type de mouvement',
          })
        }, 2000)
      } else {
        setOpenSnak({
          open: true,
          color: 'success',
          message: 'Successfully add catégorie',
        })
        setTimeout(() => {
          setOpenSnak({
            open: false,
            color: 'success',
            message: 'Account add Successfully',
          })
        }, 2000)
      }

      handleChange()
      handleClose()
    }
  }

  const handleClick = (event) => {
    let list = []

    const type = event.currentTarget.querySelector('input').name

    categories.forEach((element) => {
      if (type === 'Categorie') {
        if (!list.includes(element.Categorie)) {
          list.push(element.Categorie)
        }
      }
      if (type === 'Mouvement') {
        if (!list.includes(element.Mouvement)) {
          list.push(element.Mouvement)
        }
      }
    })

    setCategoryList(list)

    setAnchorEl(event.currentTarget)
    if (type === 'Categorie') {
      setCatOpen(true)
    }
    if (type === 'Mouvement') {
      setMouvementOpen(true)
    }
  }
  const catHandleClose = () => {
    setAnchorEl(null)
    setCatOpen(false)
    setMouvementOpen(false)
  }
  const setCatHandle = (event) => {
    const val = event.currentTarget.getAttribute('data-name')
    setCreateCategory((cate) => ({ ...cate, Categorie: val }))
    catHandleClose()
  }
  const setMouvementHandle = (event) => {
    const val = event
    // const val = event.currentTarget.getAttribute('data-name')
    if (val === 'Dépense') {
      setClassificationList([
        { label: 'Dépense nécessaire fixe', id: 'Dépense nécessaire fixe' },
        { label: 'Dépense nécessaire variable', id: 'Dépense nécessaire variable' },
        { label: 'Dépense secondaire fixe', id: 'Dépense secondaire fixe' },
        { label: 'Dépense secondaire variable', id: 'Dépense secondaire variable' },
        { label: 'Epargne', id: 'Epargne' },
      ])
    }
    if (val === 'Revenu') {
      setClassificationList([
        { label: 'Revenu', id: 'Revenu' },
        { label: 'Passive', id: 'Passive' },
        { label: 'Autre', id: 'Autre' },
      ])
    }
    setCreateCategory((cate) => ({ ...cate, Classification: '' }))
    setCreateCategory((cate) => ({ ...cate, Mouvement: val }))
    catHandleClose()
  }
  const setModuleValue = (val) => {
    setCreateCategory((cate) => ({ ...cate, Module: val }))
  }
  const setClassificationValue = (val) => {
    if (val !== '1') {
      setCreateCategory((cate) => ({ ...cate, Classification: val }))
    }
  }

  return (
    <div>
      {openSnack.open && <DirectionSnackbar message={openSnack.message} color={openSnack.color} />}
      <Button
        sx={{
          marginLeft: '5px',
          color: 'white',
          '&:hover': { color: 'black', backgroundColor: 'white' },
        }}
        onClick={handleClickOpen}
      >
        {label}
      </Button>
      <Dialog maxWidth="xs" open={open} onClose={handleClose}>
        <form onSubmit={handleSubmit}>
          <DialogTitle sx={{ color: 'black !important' }}>{label} catégorie</DialogTitle>

          <Popover
            sx={{ '.MuiPopover-paper': { maxHeight: '50%', width: 300 } }}
            id={'id-cat-menue'}
            open={catOpen}
            anchorEl={anchorEl}
            onClose={catHandleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            {categoryList.map((cat, index) => (
              <Typography
                key={index}
                data-name={cat}
                onClick={setCatHandle}
                sx={{ p: 1, ':hover': { cursor: 'pointer', background: '#d9d9d9' } }}
              >
                {cat}
              </Typography>
            ))}
          </Popover>

          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              // required
              value={createCategory.Categorie}
              name="Categorie"
              label="Categorie"
              type="text"
              autoComplete="off"
              onChange={handleChange1}
              fullWidth
              variant="standard"
              onClick={handleClick}
              aria-describedby={'id-cat-menue'}
            />

            <TextField
              // autoFocus
              required
              margin="dense"
              id="name"
              label="Sous Categorie"
              type="text"
              name="SousCategorie"
              value={createCategory.SousCategorie}
              onChange={handleChange1}
              fullWidth
              variant="standard"
            />

            <ComboBox
              handleAutoComplete={(e, j) => {
                setCreateCategory((pre) => ({ ...pre, Mouvement: j.id }))
                setMouvementHandle(j.id)
              }}
              label="Mouvement"
              data={mouvementList}
              name="Mouvement"
              required={true}
              selectedValue={mouvementList.filter((v) => v.label === createCategory.Mouvement)[0]}
            />
            {selected && selected.length === 1 ? (
              <>
                <ComboBox
                  handleAutoComplete={(e, j) => setModuleValue(j.id)}
                  label="Module"
                  data={moduleList}
                  name="Module"
                  required={true}
                  selectedValue={moduleList.filter((v) => v.label === createCategory.Module)[0]}
                />
                <ComboBox
                  handleAutoComplete={(e, j) => setClassificationValue(j.id)}
                  label="Classification"
                  data={classificationList}
                  name="Classification"
                  required={true}
                  selectedValue={
                    Classilist.filter((v) => v.label === createCategory.Classification)[0]
                  }
                />
              </>
            ) : (
              <>
                <ComboBox
                  handleAutoComplete={(e, j) => setModuleValue(j.id)}
                  label="Module"
                  data={moduleList}
                  name="Module"
                  required={true}
                />
                <ComboBox
                  handleAutoComplete={(e, j) => setClassificationValue(j.id)}
                  label="Classification"
                  data={classificationList}
                  name="Classification"
                  required={true}
                />
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}
